module.exports = ReactIntl;